<template>
    <div>
      <b-modal id="modalTelephoneOperators" ref="modalTelephoneOperators" :title="$t('Telephone operator')" hide-footer size="xl" @shown="shown">
        <div v-if="editItem">
          <b-tabs vertical pills card>
            <b-tab :title="$t('Supplier details')">
              <b-tabs pills card>
                <b-tab :title="$t('Company')">
                  <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
                    <b-form-invalid-feedback id="inputFeedbackName">
                        {{ $t('Enter title') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Short name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.short_name"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Legal address')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.jur_adress"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Actual address')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.act_adress"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('ITIN')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.inn"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Reg code')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.kpp"/>
                  </b-form-group>
                </b-tab>
                <b-tab :title="$t('Excutive managers')">
                  <b-form-group label-align="right" :label="$t('CEO')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.headman"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Accountant')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.bookeeper"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Short name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.short_headman"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Short name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.short_bookeeper"/>
                  </b-form-group>
                </b-tab>
                <b-tab :title="$t('Bank')">
                  <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="bank.name" disabled/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('City')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="bank.city" disabled/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('BIN')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="bank.bic" disabled/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Correspondent account')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="bank.kschet" disabled/>
                  </b-form-group>
                  <b-button variant="secondary" size="sm" @click="showBank">{{ $t('Select bank') }}</b-button>
                  <b-form-group label-align="right" :label="$t('Personal account')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.account"/>
                  </b-form-group>
                </b-tab>
                <b-tab :title="$t('Contract')">
                  <b-form-group label-align="right" :label="$t('Contract number')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.contract_number"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Contract place')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.contract_place"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Number format')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.number_format"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Client prefix')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.client_prefix"/>
                  </b-form-group>
                  <b-form-group label-align="right" :label="$t('Service place')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input v-model="editItem.service_place"/>
                  </b-form-group>
                </b-tab>
              </b-tabs>
            </b-tab>
            <b-tab :title="$t('Supplier balance')">
              <b-form-group label-align="right" :label="$t('Balance')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-model="editItem.balance" disabled/>
                <md-button class="md-raised" @click="showPayment" :disabled="editItem.id === 0">{{ $t('Make payyment') }}</md-button>
              </b-form-group>
            </b-tab>
            <b-tab :title="$t('Service parameters')">
              <b-form-group label-align="right" :label="$t('Free time')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-model="serviceParam.tel_service_data.cost_info.free_time" type="number"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Starting period lenght')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-model="serviceParam.tel_service_data.cost_info.first_period_length" type="number"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Starting period step')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-model="serviceParam.tel_service_data.cost_info.first_period_step" type="number"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Next period step')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-model="serviceParam.tel_service_data.cost_info.second_period_step" type="number"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Tariffcication unit size')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-model="serviceParam.tel_service_data.cost_info.time_unit_size" type="number"/>
              </b-form-group>
            </b-tab>
            <b-tab :title="$t('Price editor')">
              <md-button class="md-raised" @click="showAddTimeRange" >{{ $t('Add time range') }}</md-button>
              <md-button class="md-raised" @click="showAddTelDirections" >{{ $t('Add direction') }}</md-button>
              <md-button class="md-raised" @click="showAddTelZones" >{{ $t('Add zone') }}</md-button>

              <b-card>
                <b-table
                  striped hover small responsive fixed
                  :items="priceEditItems"
                  :fields="priceEditColumns">
                  <template v-slot:[fetchSlot(item)]="data" v-for="item in priceEditColumns">
                    <div v-if="item.key == 'direction_zone'" v-bind:key="item.key">
                      {{ data.value }}
                      <i style="margin-top:0.8rem" @click.stop="deleteCost(data.item)" class="danger fa fa-trash-alt fa-lg" />
                    </div>
                    <div v-else v-bind:key="item.key">
                      <b-form-input type="number" v-model.number="data.item[item.key].cost" v-bind:key="item.key"/>
                    </div>
                  </template>

                  <template v-slot:[fetchHead(item)]="data" v-for="item in priceEditColumns">
                    <div v-if="data.column != 'direction_zone'" v-bind:key="item.key">
                      {{ data.label }}
                      <i @click.stop="deleteTimeRange(item)" class="danger fa fa-trash-alt fa-lg" />
                    </div>
                  </template>
                </b-table>
              </b-card>
            </b-tab>
            <b-tab :title="$t('Tariffication borders')">
              <md-button class="md-raised" @click="showAddTelDirBorder" >{{ $t('Add direction') }}</md-button>
              <md-button class="md-raised" @click="showAddTelZonesBorder" >{{ $t('Add zone') }}</md-button>

              <b-card>
                <b-table
                  striped hover small responsive fixed
                  :items="tarifficationBordersItems"
                  :fields="tarifficationBordersFields">
                  <template v-slot:cell(nameTel)="data">
                    {{ data.value }}
                    <i style="margin-top:0.8rem" @click.stop="deleteBorder(data.item)" class="danger fa fa-trash-alt fa-lg" />
                  </template>
                  <template v-slot:cell(border)="data">
                    <b-form-input type="number" v-model.number="data.item.border"/>
                  </template>
                  <template v-slot:cell(cost_coefficient)="data">
                    <b-form-input type="number" v-model.number="data.item.cost_coefficient"/>
                  </template>
                </b-table>
              </b-card>
            </b-tab>

            <b-tab :title="$t('Fixed cost')">
              <md-button class="md-raised" @click="showAddTelDirFixed" >{{ $t('Add direction') }}</md-button>
              <md-button class="md-raised" @click="showAddTelZonesFixed" >{{ $t('Add zone') }}</md-button>
              <b-col class="mt-3"/>

              <b-card>
                <b-table
                  striped hover small responsive fixed
                  :items="fixedRoll"
                  :fields="fixedCostFields">
                  <template v-slot:cell(nameTel)="data">
                    {{ data.value }}
                    <i style="margin-top:0.8rem" @click.stop="deleteFixed(data.item)" class="danger fa fa-trash-alt fa-lg" />
                  </template>
                  <template v-slot:cell(cost_info)="data">
                    <b-form-input type="number" v-model.number="data.item.cost_info.fixed_cost"/>
                  </template>
                </b-table>
              </b-card>
            </b-tab>

            <b-tab :title="$t('Reports')" v-if="editItem.id > 0">
              <b-tabs pills card>
                <b-tab :title="$t('Supplier payments report')">
                  <reportPayment :editItem="editItem"/>
                </b-tab>
                <b-tab :title="$t('Supplier charges report')">
                  <reportCharges :editItem="editItem"/>
                </b-tab>
              </b-tabs>
            </b-tab>
            <b-tab :title="$t('Beeline reports')" v-if="editItem.id > 0">
              <b-tabs pills card>
                <b-tab :title="$t('Supplier users report')">
                  <reportUsers :editItem="editItem"/>
                </b-tab>
                <b-tab :title="$t('Supplier invoices report')">
                  <reportInvoices :editItem="editItem"/>
                </b-tab>
              </b-tabs>
            </b-tab>
          </b-tabs>

          <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalTelephoneOperators')" size="xl"/>
        </div>
      </b-modal>

      <b-modal ref="modalBank" size="xl"  hide-footer :title="$t('Bank')">
      <FormBank
      @selectedBank="selectBank"
       @hideFormBank="$bvModal.hide('modalBank')"/>
    </b-modal>

      <b-modal id="modalPayment" ref="modalPayment" :title="$t('Payment')" hide-footer size="lg">
        <b-form-group label-align="right" label='ID' label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="payment.id" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="payment.name" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Sum')" :disabled="payment.isResetBalance" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="payment.sum"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Currency')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select :options="currencies" v-model="payment.currency"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Reason for payment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="payment.reason"/>
        </b-form-group>
        <b-checkbox v-model="payment.isResetBalance" @change.stop="resetBalance">{{ $t('Reset balance') }}</b-checkbox>

        <modal-ok-cancel @save="savePayment" @cancel="$bvModal.hide('modalPayment')" size="lg"/>
      </b-modal>

      <b-modal id="modalTimeRange" hide-footer :title="$t('Time range')" ref="modalTimeRange" size="lg">
        <b-table striped hover
        :items="timeRangeList"
        :fields="timeRangeFields"
        selectable
        select-mode="single"
        @row-clicked="rowClickTimeRange">
        </b-table>

        <modal-ok-cancel @save="addTimeRange" @cancel="$bvModal.hide('modalTimeRange')" size="lg"/>
      </b-modal>

      <b-modal @show="clearModalTelDirs" id="modalTelDirections" hide-footer hide-header ref="modalTelDirections" size="xl">
        <table-manager-search @filterChanged="filterChangedDIRECTIONS" :options="optionsDirections"/>

        <b-table striped hover responsive small
        :items="telDirectionsItems"
        :fields="telDirectionsFields"
        selectable
        select-mode="single"
        @row-clicked="rowClickTelDirections"/>

        <table-manager-bottom
        :totalRows="telDirectionsTotal" :perPage="perPage"
        v-model="currentPage"/>

        <modal-ok-cancel @save="addTelDirections" @cancel="$bvModal.hide('modalTelDirections')" size="lg"/>
      </b-modal>

      <b-modal id="modalTelZones" hide-footer :title="$t('Telephone zones')" ref="modalTelZones" size="lg">
        <b-table striped hover
        :items="telZonesItems"
        :fields="telZonesFields"
        selectable
        select-mode="single"
        @row-clicked="rowClickTelZones">
        </b-table>
        <modal-ok-cancel @save="addTelZones" @cancel="$bvModal.hide('modalTelZones')" size="lg"/>
      </b-modal>
    </div>
</template>

<script>
import FormBank from '@/pages/users/usersAndGroups/detail/additional/formBank'
import reportPayment from './reportPayment'
import reportCharges from './reportCharges'
import reportUsers from './reportUsers'
import reportInvoices from './reportInvoices'

export default {
  components: {
    reportPayment,
    reportCharges,
    reportUsers,
    reportInvoices,
    FormBank
  },
  props: {
    editItem: null
  },
  data () {
    return {
      optionsDirections: {
        isShowAddButton: false
      },
      payment: {
        name: '',
        id: 0,
        isResetBalance: false,
        sum: 0,
        reason: '',
        currency: 810,
        inType: 0
      },
      borId: 0,
      fixedRoll: [],
      costTable: [],
      isBorder: false,
      isFixed: false,
      rowTelZones: null,
      rowTelDirections: null,
      rowTimeRange: null,
      costTimeRange: [],
      fixedCostFields: [
        {key: 'nameTel', label: this.$t('Direction/zone'), sortable: true},
        {key: 'cost_info', label: this.$t('Value'), sortable: true}
      ],
      tarifficationBordersFields: [
        {key: 'nameTel', label: this.$t('Direction/zone'), sortable: true},
        {key: 'border', label: this.$t('Border'), sortable: true},
        {key: 'cost_coefficient', label: this.$t('Coefficient'), sortable: true}
      ],
      timeRangeFields: [
        {key: 'tr_id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'range', label: this.$i18n.t('Range'), sortable: true},
        {key: 'priority', label: this.$i18n.t('Priority'), sortable: true}
      ],
      deleteImage: require('@/assets/img/document_delete.png'),

      banksFields: [
        {key: 'bank_id', label: 'ID', sortable: true},
        {key: 'bic', label: this.$i18n.t('BIN'), sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'city', label: this.$i18n.t('City'), sortable: true}
      ],
      selectedBank: null,
      bank: {
        bic: '',
        city: '',
        name: '',
        kschet: ''
      },
      telDirectionsFields: [
        {key: 'dir_id', label: 'ID'},
        {key: 'name', label: this.$i18n.t('Name')},
        {key: 'create_date', label: this.$i18n.t('Created on'), formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'update_date', label: this.$i18n.t('Updated on'), formatter: (val, key, item) => { return val ? this.$root.showDataWithTZDelta(val) : this.$i18n.t('Not installed') }},
        {key: 'zones', label: this.$i18n.t('Zone')},
        {key: 'calling_prefix', label: this.$i18n.t('Calling prefix')},
        {key: 'called_prefix', label: this.$i18n.t('Called prefix')}
      ],
      telZonesFields: [
        {key: 'zone_id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'create_date', label: this.$i18n.t('Created on'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'update_date', label: this.$i18n.t('Updated on'), sortable: true, formatter: (val, key, item) => { return val ? this.$root.showDataWithTZDelta(val) : this.$i18n.t('Not installed') }},
        {key: 'supplier_id', label: this.$i18n.t('Supplier id'), sortable: true}
      ],
      filter: '',
      perPage: 20,
      currentPage: 1
    }
  },
  methods: {
    save () {
      let tmpPriceEditItems = JSON.parse(JSON.stringify(this.priceEditItems))
      let tmpTarifficationBordersItems = JSON.parse(JSON.stringify(this.tarifficationBordersItems))
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      if (!this.serviceParam.tel_service_data.cost_info.second_period_step) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Next period step fields is invalid'), 'Error')
        return
      }
      if (!this.serviceParam.tel_service_data.cost_info.time_unit_size) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Tariffcication unit size fields is invalid'), 'Error')
        return
      }
      if (!this.costTable.length) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Price editor table is empty'), 'Error')
        return
      }

      let tmpService = {
        'supplier_id': 0,
        'tel_service_data': {
          'cost_table': [],
          'free_time': 0,
          'first_period_length': 0,
          'first_period_step': 0,
          'second_period_step': 0,
          'time_unit_size': 0,
          'discount_free_time': true
        }
      }
      tmpService.tel_service_data.time_unit_size = Number(this.serviceParam.tel_service_data.cost_info.time_unit_size)
      tmpService.tel_service_data.second_period_step = Number(this.serviceParam.tel_service_data.cost_info.second_period_step)
      if (this.serviceParam.tel_service_data.cost_info.free_time) {
        tmpService.tel_service_data.free_time = Number(this.serviceParam.tel_service_data.cost_info.free_time)
      } else {
        tmpService.tel_service_data.free_time = 0
      }
      if (this.serviceParam.tel_service_data.cost_info.first_period_length) {
        tmpService.tel_service_data.first_period_length = Number(this.serviceParam.tel_service_data.cost_info.first_period_length)
      } else {
        tmpService.tel_service_data.first_period_length = 0
      }
      if (this.serviceParam.tel_service_data.cost_info.first_period_step) {
        tmpService.tel_service_data.first_period_step = Number(this.serviceParam.tel_service_data.cost_info.first_period_step)
      } else {
        tmpService.tel_service_data.first_period_step = 0
      }
      tmpService.tel_service_data.cost_table = this.costTable
      for (let el of tmpService.tel_service_data.cost_table) {
        for (let elBorder of el.cost_info.borders) {
          elBorder.border = Number(elBorder.border)
          elBorder.cost_coefficient = Number(elBorder.cost_coefficient)
        }
      }

      for (let el of tmpService.tel_service_data.cost_table) {
        el.cost_info.costs = []
        for (let elCost of tmpPriceEditItems) {
          if (elCost.tariff_key === el.tariff_key) {
            // eslint-disable-next-line
            for (const [key, value] of Object.entries(elCost)) {
              if (value.time_range_id) {
                el.cost_info.costs.push({cost: value.cost, time_range_id: value.time_range_id})
              }
            }
            break
          }
        }

        el.cost_info.borders = []
        for (let elBorder of tmpTarifficationBordersItems) {
          if (elBorder.tariff_key === el.tariff_key) {
            el.cost_info.borders.push({border: elBorder.border, cost_coefficient: elBorder.cost_coefficient, num: elBorder.num})
          }
        }
      }

      for (let elFixed of this.fixedRoll) {
        for (let el of tmpService.tel_service_data.cost_table) {
          if (elFixed.tariff_key === el.tariff_key) {
            el.cost_info.fixed_cost = Number(elFixed.cost_info.fixed_cost)
          }
        }
      }

      if (this.editItem.id) {
        this.editItem.supplier_id = this.editItem.id
        let response = this.$store.dispatch('Settings/UPDATE_TELEPHONE_SUPPLIER', this.editItem)
        response.then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            tmpService.supplier_id = this.editItem.id
            let responseService = this.$store.dispatch('Settings/UPDATE_TELEPHONE_SUPPLIER_SERVICE', tmpService)
            responseService.then(responseService => {
              if (responseService.data.error) {
                this.$root.$emit('makeToasts', 'danger', responseService.data.error, 'Error')
              } else {
                setTimeout(this.$store.dispatch, 500, 'Settings/GET_TELEPHONE_OPERATORS')
                this.$store.dispatch('Tariffing/GET_TEL_ZONES')
                this.$refs.modalTelephoneOperators.hide()
                this.$root.$emit('makeToasts')
              }
            })
          }
        })
      } else {
        this.editItem.service = tmpService
        let response = this.$store.dispatch('Settings/CREATE_TELEPHONE_SUPPLIER_FULL', this.editItem)
        response.then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            setTimeout(this.$store.dispatch, 500, 'Settings/GET_TELEPHONE_OPERATORS')
            this.$store.dispatch('Tariffing/GET_TEL_ZONES')
            this.$refs.modalTelephoneOperators.hide()
            this.$root.$emit('makeToasts')
          }
        })
      }
    },
    async shown () {
      await this.$store.dispatch('Settings/GET_REGISTRY_SETTINGS_SYSTEM_CURRENCY')
      await this.$store.dispatch('Tariffing/GET_ALL_TEL_DIRECTIONS_LIST')
      this.costTimeRange = []
      this.fixedRoll = []
      this.costTable = []
      this.bank.bic = ''
      this.bank.city = ''
      this.bank.name = ''
      this.bank.kschet = ''
      if (this.editItem.id) {
        await this.$store.dispatch('Settings/GET_CURRENT_SUPPLIER', this.editItem.id)
        await this.$store.dispatch('Settings/GET_SUPPLIER_SERVICE', this.editItem.id)

        this.editItem.contract_number = this.currentSupplier.contract_number
        this.editItem.contract_place = this.currentSupplier.contract_place
        this.editItem.number_format = this.currentSupplier.number_format
        this.editItem.client_prefix = this.currentSupplier.client_prefix
        this.editItem.service_place = this.currentSupplier.service_place
        this.editItem.balance = this.currentSupplier.balance
        if (this.editItem.bank_id !== 0) {
          for (let el of this.banks) {
            if (el.bank_id === this.editItem.bank_id) {
              this.bank.bic = el.bic
              this.bank.city = el.city
              this.bank.name = el.name
              this.bank.kschet = el.kschet
              break
            }
          }
        }
        let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/TELEPHONE_OPERATORS_SERVICE']))
        this.costTimeRange = JSON.parse(JSON.stringify(copy.tel_service_data.cost_info.cost_table[0].cost_info.costs))
        for (let el of this.costTimeRange) {
          for (let elTimeRange of this.timeRangeList) {
            if (el.time_range_id === elTimeRange.tr_id) {
              el.nameTimeRange = elTimeRange.name
              break
            }
          }
        }
        this.borId = 0
        this.costTable = JSON.parse(JSON.stringify(copy.tel_service_data.cost_info.cost_table))
        for (let el of this.costTable) {
          for (let elBor of el.cost_info.borders) {
            elBor.num = ++this.borId
          }
          if (el.tariff_key >= 1000000) {
            for (let elDir of this.allTelDirs) {
              if (el.tariff_key === elDir.dir_id) {
                el.nameTel = elDir.name
                break
              }
            }
          } else {
            for (let elZon of this.telZonesItems) {
              if (el.tariff_key === elZon.zone_id) {
                el.nameTel = elZon.name
                break
              }
            }
          }
        }
        let arr = JSON.parse(JSON.stringify(this.costTable))
        for (let el of arr) {
          if (el.cost_info.fixed_cost) {
            this.fixedRoll.push(el)
          }
        }
      }
    },
    showBank () {
      this.selectedBank = null
      this.$refs.modalBank.show()
    },
    onRowSelected (selected) {
      this.selectedBank = selected[0]
    },
    selectBank (selectedBank) {
      this.editItem.bank_id = selectedBank.bank_id
      this.bank.bic = selectedBank.bic
      this.bank.city = selectedBank.city
      this.bank.name = selectedBank.name
      this.bank.kschet = selectedBank.kschet
      this.$refs.modalBank.hide()
    },
    showPayment () {
      this.payment = {
        name: '',
        id: 0,
        isResetBalance: false,
        sum: 0,
        reason: '',
        currency: this.$store.getters['Settings/REGISTRY_SETTINGS_SYS_CURRENCY'],
        inType: 0
      }
      this.payment.name = this.editItem.name
      this.payment.id = this.editItem.id
      this.$root.$emit('bv::show::modal', 'modalPayment', '#btnShow')
    },
    resetBalance () {
      this.payment.sum = 0
    },
    savePayment () {
      if (!Number(this.payment.sum)) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Sum fields is invalid'), 'Error')
        return
      }
      if (this.payment.sum <= 0) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Sum fields is invalid'), 'Error')
        return
      }

      if (this.payment.isResetBalance) {
        this.payment.inType = 1
      }
      let response = this.$store.dispatch('Settings/GET_MAKE_PAYMENT_FOR_SUPPLIER', this.payment)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.editItem.balance += response.data.absolute_sum
          this.$refs.modalPayment.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    showAddTimeRange () {
      this.rowTimeRange = null
      this.$refs.modalTimeRange.show()
    },
    rowClickTimeRange (row) {
      this.rowTimeRange = row
    },
    addTimeRange () {
      if (!this.rowTimeRange) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select time range'), 'Error')
        return
      }
      for (let el of this.costTimeRange) {
        if (el.time_range_id === this.rowTimeRange.tr_id) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more time range for same id'), 'Error')
          return
        }
      }
      this.rowTimeRange.cost = 0
      this.rowTimeRange.nameTimeRange = this.rowTimeRange.name
      this.rowTimeRange.time_range_id = this.rowTimeRange.tr_id
      this.costTimeRange.push(JSON.parse(JSON.stringify(this.rowTimeRange)))
      for (let curCostTable of this.costTable) {
        curCostTable.cost_info.costs.push(JSON.parse(JSON.stringify(this.rowTimeRange)))
        this.$set(curCostTable.cost_info, 'costs', curCostTable.cost_info.costs)
      }

      this.$refs.modalTimeRange.hide()
    },
    showAddTelDirections () {
      this.rowTelDirections = null
      this.isBorder = false
      this.isFixed = false
      this.$refs.modalTelDirections.show()
    },
    showAddTelDirBorder () {
      this.isBorder = true
      this.isFixed = false
      this.rowTelDirections = null
      this.$refs.modalTelDirections.show()
    },
    showAddTelDirFixed () {
      this.isBorder = false
      this.isFixed = true
      this.rowTelDirections = null
      this.$refs.modalTelDirections.show()
    },
    showAddTelZones () {
      this.isBorder = false
      this.isFixed = false
      this.rowTelZones = null
      this.$refs.modalTelZones.show()
    },
    showAddTelZonesBorder () {
      this.isBorder = true
      this.isFixed = false
      this.rowTelZones = null
      this.$refs.modalTelZones.show()
    },
    showAddTelZonesFixed () {
      this.isBorder = false
      this.isFixed = true
      this.rowTelZones = null
      this.$refs.modalTelZones.show()
    },
    rowClickTelDirections (row) {
      this.rowTelDirections = row
    },
    rowClickTelZones (row) {
      this.rowTelZones = row
    },
    addTelDirections () {
      if (!this.rowTelDirections) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select telephone direction'), 'Error')
        return
      }
      if (this.isBorder || this.isFixed) {
        let isBoolean = this.costTable.find(el => {
          return el.tariff_key === this.rowTelDirections.dir_id
        })
        if (isBoolean) {
          if (this.isBorder) {
            let newBorder = {
              'border': 0,
              'cost_coefficient': 1,
              'num': 0
            }
            for (let el of this.costTable) {
              if (el.tariff_key === this.rowTelDirections.dir_id) {
                newBorder.num = ++this.borId
                el.cost_info.borders.push(newBorder)
              }
            }
          }
          if (this.isFixed) {
            for (let el of this.fixedRoll) {
              if (el.tariff_key === this.rowTelDirections.dir_id) {
                this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more telephone direction for same id'), 'Error')
                return
              }
            }
            let newFixed = {
              'nameTel': '',
              'tariff_key': 0,
              'cost_info': {
                'fixed_cost': 0
              }
            }
            newFixed.nameTel = this.rowTelDirections.name
            newFixed.tariff_key = this.rowTelDirections.dir_id
            this.fixedRoll.push(newFixed)
          }
        } else {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Not in the table price'), 'Error')
          return
        }
      } else {
        for (let i in this.costTable) {
          if (this.costTable[i].tariff_key === this.rowTelDirections.dir_id) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more telephone direction for same id'), 'Error')
            return
          }
        }
        let newCostTable = {
          'tariff_key': 0,
          'nameTel': '',
          'cost_info': {
            'borders': [
              {
                'border': 0,
                'cost_coefficient': 1,
                'num': 0
              }
            ],
            'costs': [],
            'prepaid': 0,
            'fixed_cost': 0
          }
        }
        newCostTable.cost_info.borders[0].num = ++this.borId
        newCostTable.nameTel = this.rowTelDirections.name
        newCostTable.tariff_key = this.rowTelDirections.dir_id
        newCostTable.cost_info.costs = JSON.parse(JSON.stringify(this.costTimeRange))
        this.costTable.push(newCostTable)
      }
      this.$refs.modalTelDirections.hide()
    },
    addTelZones () {
      if (!this.rowTelZones) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select telephone zone'), 'Error')
        return
      }
      if (this.isBorder || this.isFixed) {
        let isBoolean = this.costTable.find(el => {
          return el.tariff_key === this.rowTelZones.zone_id
        })
        if (isBoolean) {
          if (this.isBorder) {
            let newBorder = {
              'border': 0,
              'cost_coefficient': 1,
              'num': 0
            }
            for (let el of this.costTable) {
              if (el.tariff_key === this.rowTelZones.zone_id) {
                newBorder.num = ++this.borId
                el.cost_info.borders.push(newBorder)
              }
            }
          }
          if (this.isFixed) {
            for (let i in this.fixedRoll) {
              if (this.fixedRoll[i].tariff_key === this.rowTelZones.zone_id) {
                this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more telephone direction for same id'), 'Error')
                return
              }
            }
            let newFixed = {
              'nameTel': '',
              'tariff_key': 0,
              'cost_info': {
                'fixed_cost': 0
              }
            }
            newFixed.nameTel = this.rowTelZones.name
            newFixed.tariff_key = this.rowTelZones.zone_id
            this.fixedRoll.push(newFixed)
          }
        } else {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Not in the table price'), 'Error')
          return
        }
      } else {
        for (let el of this.costTable) {
          if (el.tariff_key === this.rowTelZones.zone_id) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more telephone direction for same id'), 'Error')
            return
          }
        }
        let newCostTable = {
          'tariff_key': 0,
          'nameTel': '',
          'cost_info': {
            'borders': [
              {
                'border': 0,
                'cost_coefficient': 1,
                'num': 0
              }
            ],
            'costs': [],
            'prepaid': 0,
            'fixed_cost': 0
          }
        }
        newCostTable.cost_info.borders[0].num = ++this.borId
        newCostTable.nameTel = this.rowTelZones.name
        newCostTable.tariff_key = this.rowTelZones.zone_id
        newCostTable.cost_info.costs = JSON.parse(JSON.stringify(this.costTimeRange))
        this.costTable.push(newCostTable)
      }
      this.$refs.modalTelZones.hide()
    },
    deleteTimeRange (item) {
      this.costTimeRange = this.costTimeRange.filter((value) => {
        return value.time_range_id !== item.time_range_id
      })
      for (let curTable of this.costTable) {
        curTable.cost_info.costs = curTable.cost_info.costs.filter((value) => {
          return value.time_range_id !== item.time_range_id
        })
      }
    },
    deleteCost (item) {
      this.costTable = this.costTable.filter((value) => {
        return value.tariff_key !== item.tariff_key
      })
    },
    deleteFixed (item) {
      this.fixedRoll = this.fixedRoll.filter((value) => {
        return value.tariff_key !== item.tariff_key
      })
    },
    deleteBorder (item) {
      for (let el of this.costTable) {
        el.cost_info.borders = el.cost_info.borders.filter((value) => {
          return value.num !== item.num
        })
      }
    },
    fetchSlot (key) {
      return `cell(${key.key})`
    },
    fetchHead (key) {
      return `head(${key.key})`
    },
    filterChangedDIRECTIONS (value) {
      this.filter = value
      if (this.currentPage === 1) {
        this.$store.dispatch('Tariffing/GET_TEL_DIRECTIONS_LIST', {'count': this.perPage, 'offset': (this.currentPage - 1) * this.perPage, 'filter': value})
      } else {
        this.currentPage = 1
      }
    },
    clearModalTelDirs () {
      this.filter = ''
      this.currentPage = 1
      this.$store.dispatch('Tariffing/GET_TEL_DIRECTIONS_LIST', {'count': 20, 'offset': 0, 'filter': ''})
    }
  },
  computed: {
    telDirectionsTotal () {
      return JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TEL_DIRECTIONS_LIST'].total))
    },
    tarifficationBordersItems () {
      let items = []
      for (let el of this.costTable) {
        for (let border of el.cost_info.borders) {
          let newEl = {}
          newEl.nameTel = el.nameTel
          newEl.tariff_key = el.tariff_key
          // eslint-disable-next-line
          for (const [key, value] of Object.entries(border)) {
            newEl[key] = value
          }
          items.push(newEl)
        }
      }
      return items
    },
    priceEditItems () {
      let items = []
      for (let el of this.costTable) {
        let newEl = {}
        newEl.direction_zone = el.nameTel
        newEl.tariff_key = el.tariff_key
        for (let elCostIDx in el.cost_info.costs) {
          let key = this.priceEditColumns[Number(elCostIDx) + 1].key
          newEl[key] = { 'cost': el.cost_info.costs[elCostIDx].cost, 'time_range_id': el.cost_info.costs[elCostIDx].time_range_id }
        }
        items.push(newEl)
      }
      return items
    },
    priceEditColumns () {
      let columns = [{key: 'direction_zone', label: this.$t('Direction/zone'), sortable: true}]
      for (let el of this.costTimeRange) {
        let newEl = {key: el.nameTimeRange, label: el.nameTimeRange, sortable: true, time_range_id: el.time_range_id}
        columns.push(newEl)
      }
      return columns
    },
    currencies () {
      let res = []
      for (let el of this.$store.getters['ReferenceBooks/CURRENCIES']) {
        let newEl = {}
        newEl.value = el.currency_id.toString()
        newEl.text = el.currency_brief_name
        res.push(newEl)
      }
      return res
    },
    currentSupplier () {
      return this.$store.getters['Settings/CURRENT_SUPPLIER']
    },
    timeRangeList () {
      return this.$store.getters['Tariffing/TIME_RANGE']
    },
    telDirectionsItems () {
      return this.$store.getters['Tariffing/TEL_DIRECTIONS_LIST'].items
    },
    telZonesItems () {
      return this.$store.getters['Tariffing/TEL_ZONES']
    },
    sysCurrency () {
      return this.$store.getters['Settings/REGISTRY_SETTINGS_SYS_CURRENCY']
    },
    serviceParam () {
      let serviceParam = {
        tel_service_data: {
          cost_info: {
            free_time: '',
            first_period_length: '',
            first_period_step: '',
            second_period_step: 1,
            time_unit_size: 60
          }
        }
      }
      if (this.editItem.id) {
        serviceParam = this.$store.getters['Settings/TELEPHONE_OPERATORS_SERVICE']
      }
      return serviceParam
    },
    allTelDirs () {
      return this.$store.getters['Tariffing/ALL_TEL_DIRECTIONS_LIST'].items
    }
  },
  watch: {
    sysCurrency: function (val) {
      this.payment.currency = val
    },
    currentPage (val) {
      this.$store.dispatch('Tariffing/GET_TEL_DIRECTIONS_LIST', {'count': this.perPage, 'offset': (val - 1) * this.perPage, 'filter': this.filter})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/telephony/telephoneOperators/editModal.vue